.container {
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  max-height: var(--mirai-modal-max-height);
  padding: var(--mirai-ui-space-XS);
  overflow-y: auto;
}
